import React, { useEffect } from 'react';
import {
    Datagrid,
    TextField,
    ShowButton,
    ReferenceManyField,
    Pagination,
    useListContext,
} from 'react-admin';
import { ReferenceField } from 'react-admin';

const DatagridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total Communications: {total || 0}
                </div>
            )}
            <Datagrid>
                <TextField source="serial" sortable={false} />
                <TextField source="id" label="Communication Id" />
                <TextField source="taskStatus" label="Task Status" />
                <TextField source="taskType" label="Task Type" />
                <TextField source="templateName" label="Template Name" />
                <TextField source="senderEmail" label="Sender Email" />
                <TextField source="recipientEmail" label="Recipient Email" />
                <TextField source="channel" label="Channel" />
                <TextField source="deliveryStatus" label="Delivery Status" />
                <ShowButton />
            </Datagrid>
            <Pagination />
        </>
    );
};

export const OrderCommunicationsList = props => {
    useEffect(() => {
        localStorage.setItem(
            'currentComMod',
            `/orders/${props.record.id}/show/7`
        );
    }, []);
    return (
        <ReferenceManyField
            reference="Communication-records"
            target="resourceId"
            perPage={25}
            filter={{ resourceId: props.record.id, resourceType: 'order' }}
            {...props}
        >
            <DatagridWithTotal />
        </ReferenceManyField>
    );
};
